'use strict';

/*
 * Directive for browser printing. This works with CSS rules that define
 * explicit printing rules
 */
angular.module('v6CoreModule').directive('printElement', (printer) => {
  let linkFn;
  linkFn = (scope, element, attrs) => {
    // Sends to printer method to update [print-element]
    printer.setBrowserCallback((content) => {
      $(element).html(content);
    });
  };

  return {
    restrict: 'A',
    link: linkFn,
  };
});
